import React, { useEffect, useState } from 'react';
import Link from './Link';
import InlineSvg from './InlineSvg';

export default function DocumentBlock(props) {
  const getIcon = (document_type) => {
    switch (document_type) {
      case 'fact-sheet':
        return 'icon-fact-sheet';
      case 'policy':
        return 'icon-fact-sheet';
      case 'report':
        return 'icon-fact-sheet';
      case 'video':
        return 'icon-external-link';
      case 'audio':
        return 'icon-external-link';
      case 'image':
        return 'icon-external-link';
      default:
        return 'icon-fact-sheet';
    }
  };

  const Resource = (props) => {
    const { document, hasFade, handleShowDocuments } = props;
    const resourceLink = document.documentFields?.externalResource
      ? document.documentFields?.externalResource
      : document.documentFields?.file?.mediaItemUrl;

    const fileSize = document?.documentFields?.file?.fileSize;

    console.log(props)

    const getFileExtension = (url) => {
      const array = url?.split('.');

      if (array?.length) {
        return array.pop();
      }
    };

    const getFileSize = (fileSize) => {
      if (fileSize) {
        const megabytes = Number(fileSize) / (1024 * 1024);
        return megabytes.toFixed(2);
      }
    };

    return (
      <li
        className="documents-and-resources__list-item"
        onClick={() => {
          if (!hasFade) {
            return;
          }
          handleShowDocuments();
        }}
        role="presentation"
      >
        <Link to={resourceLink} target="_blank" rel="noreferrer noopener" className="documents-and-resources__link no-decoration body-two">
          <div className="documents-and-resources__icon">
            <InlineSvg
              name={getIcon(document.documentFields.documentType)}
              width="34"
              color={document?.documentFields?.documentOwner === 'powercor' ? 'red' : 'blue'}
            />
          </div>
          <span
            className="body-two documents-and-resources__file-text"
            dangerouslySetInnerHTML={{
              __html: document.title ? document.title : '',
            }}
          />
        </Link>
        <div className="documents-and-resources__document-meta">
          {fileSize ? <span>{getFileSize(fileSize)} MB</span> : null}
          {getFileExtension(resourceLink)}
        </div>
      </li>
    );
  };

  const handleShowDocuments = () => {
    setDocumentsSlice(props.documentBlock?.documents);
    setAllDocumentsAreShowing(true);
  };

  const [documentsArray, setDocumentsArray] = useState([]);
  const [documentsSlice, setDocumentsSlice] = useState([]);
  const [documentCount, setDocumentCount] = useState(0);
  let documentIndex = props.documentBlock?.documents?.length;
  const [allDocumentsAreShowing, setAllDocumentsAreShowing] = useState(documentIndex <= 8);

  useEffect(() => {
    setDocumentsArray(props.documentBlock?.documents || []);
  }, [props.documentBlock?.documents]);

  useEffect(() => {
    setDocumentsSlice(documentsArray.slice(0, 8));
    setDocumentCount(documentIndex);
  }, [documentsArray, documentIndex]);

  return (
    <div className={`${'documents-and-resources__list-container'} ${!allDocumentsAreShowing ? 'documents-and-resources__faded' : null}`}>
      {props.documentBlock?.heading && (
        <h3 className="documents-and-resources__list-heading heading-four">{props.documentBlock.heading}</h3>
      )}
      <ul className="documents-and-resources__list">
        {documentsSlice.map((document, i) => {
          return (
            <Resource
              key={i}
              document={document}
              hasFade={!allDocumentsAreShowing && [6, 7].includes(i)}
              handleShowDocuments={handleShowDocuments}
            />
          );
        })}
      </ul>
      {documentCount > 8 && !allDocumentsAreShowing ? (
        <button onClick={handleShowDocuments} className="documents-and-resources__show-all-button button button--outline">
          Show all {documentCount} documents
        </button>
      ) : null}
    </div>
  );
}
